module.exports = __webpack_public_path__ + "static/media/11_1.5c1feb8c.png";